import React from 'react';
import ImpContainer from '../../Atoms/ImpContainer/ImpContainer';
import ImpFlex from '../../Atoms/ImpFlex/ImpFlex';
import ImpPad from '../../Atoms/ImpPad/ImpPad';
import { colors } from '../../DesignSystem/colors';
import { borderRadius, spacing } from '../../DesignSystem/design-system';
import ImpText from '../ImpText/ImpText';
import ImpIcon from '../ImpIcon/ImpIcon';
import ImpSpacer from '../../Atoms/ImpSpacer/ImpSpacer';
const getBackgroundColor = (variant, color) => {
    if (variant === 'primary')
        return color;
    return 'transparent';
};
const getTextColor = (variant, color) => {
    if (variant === 'primary')
        return 'white';
    return color;
};
const getBorder = (variant, color) => {
    if (variant === 'primary')
        return 'none';
    return `1px solid ${color}`;
};
export default function ImpBadgeText({ variant = 'secondary', typography = 'overline', color = colors.content.onBackground, children, leadingIcon, }) {
    return (React.createElement(ImpContainer, { backgroundColor: getBackgroundColor(variant, color), width: "fit-content", borderRadius: borderRadius.xl, border: getBorder(variant, color), dataTestId: "badge-container" },
        React.createElement(ImpPad, { padding: `${spacing.xs} ${spacing.m}` },
            React.createElement(ImpFlex, { fluid: true, align: "center", justify: "center" },
                leadingIcon &&
                    React.createElement(ImpFlex, { direction: 'row', align: 'center' },
                        React.createElement(ImpIcon, { iconSrc: leadingIcon, stroke: getTextColor(variant, color), size: '12px' }),
                        React.createElement(ImpSpacer, { width: spacing.xs })),
                React.createElement(ImpText, { dataTestId: "badge-text", typography: typography, color: getTextColor(variant, color) }, children)))));
}
//# sourceMappingURL=ImpBadgeText.js.map